import { format } from 'date-fns';
import { SEARCH_FORMAT_DATE } from '@ts/utils/constants';
import { Analytics } from '..';

export default function navigation(self: Analytics) {
    return {
        clickedLogotype() {
            self.DataLayerEvent({
                action: 'Clicked Logotype',
                category: 'Navigation',
                nonInteraction: false,
            });
            return self;
        },

        clickedCartButton() {
            self.DataLayerEvent({
                action: 'Clicked Cart',
                category: 'Navigation',
                label: 'Button',
                nonInteraction: false,
            });
            return self;
        },

        clickedWishButton() {
            self.DataLayerEvent({
                action: 'Clicked Wish',
                category: 'Navigation',
                label: 'Button',
                nonInteraction: false,
            });
            return self;
        },

        clickedSearchButton({
            destination,
            category,
        }: {
            destination?: { name: string };
            category?: { name: string };
        }) {
            self.DataLayerEvent({
                action: 'Clicked Search',
                category: 'Navigation',
                label: 'Button',
                nonInteraction: false,
            });

            if (!destination) {
                return self;
            }

            self.fbq('track', 'Search', {
                search_string: [destination.name, category && category.name]
                    .filter(Boolean)
                    .join(' / '),
            });

            return self;
        },

        selectedSearch({
            destination,
            category,
        }: {
            destination?: { name: string };
            category?: { name: string };
        }) {
            if (!destination) {
                return self;
            }
            self.DataLayerEvent({
                action: 'Selected Search',
                category: 'Navigation',
                label: [destination.name, category && category.name].filter(Boolean).join(' / '),
                nonInteraction: false,
            });
            return self;
        },

        selectedSearchDates({ startDate, endDate }: { startDate?: Date; endDate?: Date }) {
            if (!startDate) {
                return self;
            }

            const label = [startDate, endDate]
                .filter(Boolean)
                .map((date) => format(date as Date, SEARCH_FORMAT_DATE))
                .join(' ~ ');

            self.DataLayerEvent({
                action: 'Selected Search Dates',
                category: 'Navigation',
                label,
                nonInteraction: false,
            });
            return self;
        },
    };
}
